export const getAuthHeader = (state) => {
  const { token } = state.user;

  return {
    Authorization: token ? `Bearer ${token}` : null,
  };
};
